import React from 'react';
import { Header } from './Header';
import { StorySection } from './StorySection';
import { ProductSection } from './ProductSection';
import { TestimonialSection } from './TestimonialSection';
import { ReviewSection } from './ReviewSection';
import { CTASection } from './CTASection';
import { Footer } from './Footer';
export const Advertorial = () => {
  return <div className="max-w-3xl mx-auto bg-white shadow-md" data-id="element-8">
      <Header data-id="element-9" />
      <main className="px-4 md:px-8" data-id="element-10">
        <StorySection data-id="element-11" />
        <ProductSection data-id="element-12" />
        <TestimonialSection data-id="element-13" />
        <ReviewSection data-id="element-14" />
        <CTASection data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
};